var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.hasStepManager == true)?_c('StepManager',{attrs:{"steps":_vm.steps}}):_vm._e(),_c('div',{staticClass:"container-fluid"},[_c('Wizard',{attrs:{"steps":_vm.steps,"tags":_vm.tags}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }